import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import { loginByToken } from "@/api/login/login";

const app = createApp(App)

app.use(store)
  .use(router)
  .use(ViewUIPlus)
  .mount('#app')

const value = localStorage.getItem('token');
const userInfo = localStorage.getItem('userInfo');
store.dispatch('updateToken', value)
if (userInfo) {
  store.dispatch('updateUserInfo', JSON.parse(userInfo))
}
const token = store.getters.getToken
if (token) {
  loginByToken().then(res => {
    if (res.code == 0) {
      localStorage.setItem('userInfo', JSON.stringify(res.data.user));
      store.dispatch('updateUserInfo', res.data.user)
    }
  })
} else {
  router.replace('/login')
}
